/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Skeleton } from 'antd'
import colors from '@sportninja/common/constants/appColors'
import React from 'react'
import { MODAL_TOKENS } from 'src/styles/modalTokens'

/** Card-shaped shimmer shown during the first candidates fetch. */
const PlayerFinderSkeleton: React.FC = () => (
  <div css={wrapStyle} data-testid='player-finder-skeleton'>
    {[0, 1, 2, 3].map((i) => (
      <div key={i} css={cardStyle}>
        <Skeleton active avatar paragraph={{ rows: 2 }} title={false} />
      </div>
    ))}
  </div>
)

export default PlayerFinderSkeleton

/* Mirrors the real list's two-column grid so the loading state doesn't reflow
   into a different shape once candidates arrive. */
const wrapStyle = css`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: ${MODAL_TOKENS.MOBILE_BREAKPOINT}px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

/* Same raised surface as the real card (see SpareCandidateCard). */
const cardStyle = css`
  padding: 14px;
  border: 1px solid ${colors.SOFT_STEEL};
  border-radius: 12px;
  background-color: ${colors.SECONDARY_300};
`
